import jwt from "jsonwebtoken";
import {ActionTypes} from "../contants/Action.Type";
import {safeLocalStorage} from "../../Utils/storage";

const getStoredToken = () => {
  try {
    return safeLocalStorage.getItem("Token") || "";
  } catch {
    return "";
  }
};

const getUserData = () => {
  try {
    const token = safeLocalStorage.getItem("Token");
    return token ? jwt.decode(token) || [] : [];
  } catch {
    return [];
  }
};

const Auth = {
  Token: getStoredToken(),
  isAuth: false,
  userData: getUserData(),
  Loading: false,
  lockScreen: false,
  lockPop: false,
  company: [],
};

export const authReducer = (state = Auth, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_LOGIN_TOKEN:
      return {
        ...state,
        Token: payload.Token,
        isAuth: payload.Auth,
        userData: payload.userData,
      };
    case ActionTypes.SET_LOGOUT:
      return {
        ...state,
        Token: payload.Token,
        isAuth: payload.Auth,
        userData: payload.userData,
        lockScreen: false,
        lockPop: false,
      };
    case ActionTypes.SET_LOADING:
      return { ...state, Loading: payload };
    case ActionTypes.SET_SCREEN_LOCK:
      return { ...state, lockScreen: payload };
    case ActionTypes.SET_SCREEN_UNLOCK:
      return { ...state, lockPop: payload };
    case ActionTypes.SET_COMPANY_INFO:
      return { ...state, company: payload };
    case ActionTypes.SET_SCREEN_AUTH:
      return {
        ...state,
        Token: payload.Token,
        isAuth: payload.Auth,
        userData: payload.userData,
        lockScreen: false,
        lockPop: false,
      };
    default:
      return state;
  }
};